import type { CardType } from './engine'

export interface DragPayload {
  type: CardType
  kind: 'action' | 'control'
  /** Pre-set param for activity-mode palette cards (skips the dropdown). */
  param?: number
}

let current: DragPayload | null = null

export function setDrag(payload: DragPayload | null): void {
  current = payload
}

export function getDrag(): DragPayload | null {
  return current
}

// ── Touch drag ghost ──────────────────────────────────────────────────────────

let ghost: HTMLElement | null = null

export function createDragGhost(label: string, accentColor: string): void {
  ghost = document.createElement('div')
  Object.assign(ghost.style, {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: '9999',
    background: accentColor,
    borderRadius: '8px',
    padding: '6px 12px',
    fontSize: '13px',
    fontWeight: '800',
    color: '#fff',
    boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
    transform: 'rotate(-3deg) scale(1.05)',
    opacity: '0.92',
    whiteSpace: 'nowrap',
    left: '-200px',
    top: '-200px',
  })
  ghost.textContent = label
  document.body.appendChild(ghost)
}

export function moveDragGhost(x: number, y: number): void {
  if (!ghost) return
  ghost.style.left = `${x - 50}px`
  ghost.style.top = `${y - 20}px`
}

export function destroyDragGhost(): void {
  ghost?.remove()
  ghost = null
}

// ── Drop zone registry ────────────────────────────────────────────────────────

const dropRegistry = new Map<Element, () => void>()

export function registerDropZone(el: Element, handler: () => void): () => void {
  dropRegistry.set(el, handler)
  return () => dropRegistry.delete(el)
}

export function triggerDropAtPoint(x: number, y: number): void {
  // Temporarily hide ghost so elementFromPoint finds what's beneath it
  if (ghost) ghost.style.display = 'none'
  let el: Element | null = document.elementFromPoint(x, y)
  if (ghost) ghost.style.display = ''

  while (el) {
    const handler = dropRegistry.get(el)
    if (handler) {
      handler()
      return
    }
    el = el.parentElement
  }
}
